export { default as BottomFixedContent } from './BottomFixedContent'
